import React from 'react';
import Select from '../../../../components/Select';
import Box from '../../../../components/Box';

export default class ReportConfig extends React.Component {
  shouldComponentUpdate(nextProps) {
    return this.props.config.combinedStats !== nextProps.config.combinedStats;
  }

  handleChange = (e) => {
    const key = e.target.id;
    let value = (e.target.checked === undefined ?
      e.target.value : e.target.checked);
    try {
      value = JSON.parse(value)
    } catch(e) {}
    this.props.onChange(key, value);
  };

  render() {
    const { config } = this.props;

    return (
      <Box title="Report Configuration" className="hidden-print">
        <form role="form">
          <div className="row">
            <div className="col-md-2">
              <div className="form-group">
                <Select id="combinedStats"
                        onChange={ this.handleChange }
                        value={ config.combinedStats }
                        label="One League / Combined"
                        options={[
                          { key: "false", value: "One League" },
                          { key: "true", value: "Combined" }
                        ]} />
              </div>
              <div className="form-group">
                <Select id="lastResults"
                        onChange={ this.handleChange }
                        value={ config.lastResults }
                        label="Last Results/Stats"
                        options={[
                          { key: "false", value: "Hide Last Results/Stats" },
                          { key: "3", value: "Show Last 3 Games" },
                          { key: "5", value: "Show Last 5 Games" },
                          { key: "7", value: "Show Last 7 Games" }
                        ]} />
              </div>
            </div>
            {/* /.col */}
            <div className="col-md-2 col-md-offset-1">
              <div className="form-group">
                <label>Team Stats</label>
                <div className="checkbox">
                  <label>
                    <input type="checkbox"
                           id="showAccumulatedStats"
                           defaultChecked={ config.showAccumulatedStats }
                           onChange={ this.handleChange } />
                    Accumulated Stats
                  </label>
                </div>
              </div>
              <div className="form-group">
                <div className="checkbox">
                  <label>
                    <input type="checkbox"
                           id="showTeamRank"
                           defaultChecked={ config.showTeamRank }
                           disabled={ config.combinedStats }
                           onChange={ this.handleChange } />
                    Team Rank
                  </label>
                </div>
              </div>
              <div className="form-group">
                <div className="checkbox">
                  <label>
                    <input type="checkbox"
                           id="showStatsBreakdown"
                           defaultChecked={ config.showStatsBreakdown }
                           onChange={ this.handleChange } />
                    Stats Breakdown
                  </label>
                </div>
              </div>
              <div className="form-group">
                <div className="checkbox">
                  <label>
                    <input type="checkbox"
                           id="showStartersBench"
                           defaultChecked={ config.showStartersBench }
                           onChange={ this.handleChange } />
                    Starters Vs. Bench
                  </label>
                </div>
              </div>
            </div>
            {/* /.col */}
            <div className="col-md-2 col-md-offset-1">
              <div className="form-group">
                <Select id="bestWorst"
                        onChange={ this.handleChange }
                        value={ config.bestWorst }
                        label="Best / Worst"
                        options={[
                          { key: "true", value: "Show All Games" },
                          { key: "3", value: "Show Last 3 Games" },
                          { key: "5", value: "Show Last 5 Games" },
                          { key: "7", value: "Show Last 7 Games" },
                          { key: "false", value: "Hide Best/Worst" }
                        ]} />
              </div>
              <div className="form-group">
                <Select id="playersOrderBy"
                        onChange={ this.handleChange }
                        value={ config.playersOrderBy }
                        label="Order players by"
                        options={[
                          { key: "grid", value: "Roster" },
                          { key: "jersey", value: "Jersey #" },
                          { key: "position", value: "Position" }
                        ]} />
              </div>
            </div>
            {/* /.col */}
            <div className="col-md-2 col-md-offset-1">
              <div className="form-group">
                <label>Players Stats</label>
                <div className="checkbox">
                  <label>
                    <input type="checkbox"
                           id="showPlayersStatsWonGames"
                           defaultChecked={ config.showPlayersStatsWonGames }
                           onChange={ this.handleChange } />
                    Won Games
                  </label>
                </div>
              </div>
              <div className="form-group">
                <div className="checkbox">
                  <label>
                    <input type="checkbox"
                           id="showPlayersStatsLostGames"
                           defaultChecked={ config.showPlayersStatsLostGames }
                           onChange={ this.handleChange } />
                    Lost Games
                  </label>
                </div>
              </div>
              <div className="form-group">
                <div className="checkbox">
                  <label>
                    <input type="checkbox"
                           id="showPlayersStatsHomeGames"
                           defaultChecked={ config.showPlayersStatsHomeGames }
                           onChange={ this.handleChange } />
                    Home Games
                  </label>
                </div>
              </div>
              <div className="form-group">
                <div className="checkbox">
                  <label>
                    <input type="checkbox"
                           id="showPlayersStatsAwayGames"
                           defaultChecked={ config.showPlayersStatsAwayGames }
                           onChange={ this.handleChange } />
                    Away Games
                  </label>
                </div>
              </div>
              <div className="form-group">
                <div className="checkbox">
                  <label>
                    <input type="checkbox"
                           id="showPlayersStatsAllGames"
                           defaultChecked={ config.showPlayersStatsAllGames }
                           onChange={ this.handleChange } />
                    All Games
                  </label>
                </div>
              </div>
              <div className="form-group">
                <div className="checkbox">
                  <label>
                    <input type="checkbox"
                           id="showPlayersStatsTotal"
                           defaultChecked={ config.showPlayersStatsTotal }
                           onChange={ this.handleChange } />
                    Total Row
                  </label>
                </div>
              </div>
            </div>
            {/* /.col */}
          </div>
          {/* /.row */}
        </form>
      </Box>
    );
  }
};



// WEBPACK FOOTER //
// ./src/features/scout-report/components/ReportConfig/ReportConfig.js